export default __webpack_public_path__ + "static/4-51eb7096c54fab0ed92ce797aee71a41.png";